module.exports = __webpack_public_path__ + "static/media/dark.12be35fc.png";